import { homeHeroResponsiveUrls } from "../../lib/cdn-base.js";
import RapidmailNewsletterSection from "./rapidmail-newsletter-section.marko";

static const heroImg = homeHeroResponsiveUrls("/img/index/lernlaterne-new.png");

<div class="container">
  <section class="hero hero--home">
    <div class="hero__text">
      <p class="hero__eyebrow">${input.data.home.eyebrow}</p>
      <h1 class="hero__title">${input.data.home.heroTitle}</h1>
      <p class="hero__desc">${input.data.home.heroDescription}</p>
      <if=(input.data.targetLanguageCtas || []).length>
        <p class="hero__eyebrow" style="margin-bottom:var(--space-sm)">${input.data.home.targetLanguageCtaLabel}</p>
        <div class="hero__actions">
          <for|langCta| of=(input.data.targetLanguageCtas || [])>
            <if=langCta.available>
              <a class="btn btn--accent btn--lg" href=langCta.href>${langCta.label}</a>
            </if>
          </for>
          <button type="button" class="btn btn--inactive btn--lg" disabled>${input.data.home.moreLanguagesComingSoon}</button>
        </div>
      </if>
    </div>
    <div class="hero__media">
      <img
        src=heroImg.src
        srcset=heroImg.srcSet
        sizes=heroImg.sizes
        alt=(($global.locale || {}).seo?.siteName || "")
        class="hero__image"
        width="800"
        height="600"
        fetchpriority="high"
        onerror="this.style.display='none'"
      >
    </div>
  </section>
</div>

<section class="section section--home-about" style="background:var(--color-bg-card); border-top:1px solid var(--color-border); border-bottom:1px solid var(--color-border)">
  <div class="container">
    <div class="prose" style="max-width:860px; margin:0 auto">
      <p class="hero__eyebrow">${input.data.home.aboutProjectEyebrow}</p>
      <h2 class="section__title" style="margin-bottom:var(--space-md)">${input.data.home.aboutProjectTitle}</h2>
      <p class="about-section__text">${input.data.home.aboutProjectParagraph1}</p>
      <p class="about-section__text">${input.data.home.aboutProjectParagraph2}</p>
    </div>
  </div>
</section>

<section class="section section--home-about">
  <div class="container">
    <div class="prose" style="max-width:860px; margin:0 auto">
      <p class="hero__eyebrow">${input.data.home.aboutMeEyebrow}</p>
      <h2 class="section__title" style="margin-bottom:var(--space-md)">${input.data.home.aboutMeTitle}</h2>
      <p class="about-section__text">${input.data.home.aboutMeParagraph1}</p>
      <p class="about-section__text">${input.data.home.aboutMeParagraph2}</p>
      <p class="about-section__text">${input.data.home.aboutMeParagraph3}</p>
    </div>
  </div>
</section>

<section class="section ll-home-newsletter-band">
  <div class="container" style="max-width:860px">
    <RapidmailNewsletterSection newsletter=($global.locale && $global.locale.newsletter)/>
  </div>
</section>
